import { useState } from "react"
import useHashObserver from "./useHashObserver"
import useScrollToAndHighlight from "./useScrollToAndHighlight"

// This hook does 2 things (via its delegated hooks):
// 1. Observes the target element (or its specified children)
// to update the hash with the element's ID when it intersects the viewport
// 2. Scrolls to and highlight the element with the hash ID when the hash changes
// currently applies scroll and highlight on initial load
const useScrollToHashWithHashObserver = ({
  selector,
  shouldScroll = true,
  enableObserver = true,
  resolveElementId,
  highlightClass,
  styleId
}: {
  selector: string
  shouldScroll?: boolean
  /** When false, hash is not updated when elements intersect viewport. Default true. */
  enableObserver?: boolean
  resolveElementId?: (hashId: string) => string | null | undefined
  highlightClass?: string
  styleId?: string
}) => {
  const [isScrolling, setIsScrolling] = useState(false)

  useScrollToAndHighlight({
    onScrollStart: () => setIsScrolling(true),
    onScrollEnd: () => setIsScrolling(false),
    isActive: shouldScroll,
    resolveElementId,
    highlightClass,
    styleId
  })

  useHashObserver({
    selector,
    isActive: enableObserver && !isScrolling
  })

  return null
}

export default useScrollToHashWithHashObserver
